import React, { PureComponent } from 'react';

// COMPONENTS
import Layout from '../../pages/Layout';
import Hero from '../../components/Hero/Hero';
import KlickLoadable from '../../components/KlickLoadable/KlickLoadable';

// TRACKING UTILS
import {
  addTrackingPixel,
  fireDCMTrackingEvent,
  isPreRendering,
} from '../../common/utils.js';

class Home extends PureComponent {
  componentDidMount = () => {
    setTimeout(() => {
      this.trackPageView();
    }, 1);
  };

  trackPageView = () => {
    fireDCMTrackingEvent('klick0+standard');
    addTrackingPixel(
      'https://r.turn.com/r/beacon?b2=vhSWrTqIYHxEgMkam0WLIlWgP5zrjdWywnvqQzFzpSrfa_8gJLhxvuTF1O2cFhlvl8Oyw-llpU1wYgegNMb2xg&cid='
    );
  };

  render = () => {
    return (
      <Layout>
        <Hero location={this.props.location} />
        {!isPreRendering && <KlickLoadable />}
      </Layout>
    );
  };
}

export default Home;
